// material-ui
import { useTheme } from "@mui/material/styles";

// types
import { ThemeMode } from "shared/types/config";

type LogoProps = {
  width?: string;
  height?: string;
};

const PlateLogo = ({ width = "120", height = "30" }: LogoProps) => {
  const theme = useTheme();
  const textColor = theme.palette.mode === ThemeMode.DARK ? "#FFFF" : "#1D1D1F";
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 520 160`}
      xmlns='http://www.w3.org/2000/svg'
    >
      <text
        x='80'
        y='120'
        fontFamily='Inter, Arial, sans-serif'
        fontSize='120'
        fontWeight='800'
        fill={textColor}
      >
        PLATE
      </text>

      {/* <rect x='360' y='25' width='48' height='48' rx='8' fill='#D90429' />

      <rect x='332' y='56' width='56' height='56' rx='10' fill='#0B63B6' />

      <rect x='360' y='88' width='48' height='48' rx='8' fill='#F5C518' /> */}
    </svg>
  );
};

export default PlateLogo;
